import Instance from "../../../Axios";

const GetPlusServices = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/services`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_SERVICES", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusServices;
